<script setup lang="ts">
import BaseTabs from '@/components/BaseTabs.vue'
import DatabaseAssemblies from '@/components/DatabaseAssemblies.vue'
import DatabaseCostSources from '@/components/DatabaseCostSources.vue'
import DatabaseEquipment from '@/components/DatabaseEquipment.vue'
import DatabaseEstimateStatus from '@/components/DatabaseEstimateStatus.vue'
import DatabaseEstimateTypes from '@/components/DatabaseEstimateTypes.vue'
import DatabaseItems from '@/components/DatabaseItems.vue'
import DatabaseLabor from '@/components/DatabaseLabor.vue'
import DatabaseUnitsOfMeasure from '@/components/DatabaseUnitsOfMeasure.vue'
import { ref } from 'vue'

const tabs = ['Items', 'Assemblies', 'Sources', 'Labor', 'Equipment', 'UOM', 'Status', 'Types']
const currentTab = ref<(typeof tabs)[number]>('Items')
</script>

<template>
  <div class="flex h-full w-full flex-col">
    <header class="bg-blue-300 p-4 text-xl font-bold"><h1>Database</h1></header>
    <BaseTabs :tabs="tabs" v-model="currentTab">
      <!-- End Navigation Tabs -->
      <DatabaseItems v-if="currentTab === 'Items'" />
      <DatabaseAssemblies v-else-if="currentTab === 'Assemblies'" />
      <DatabaseCostSources v-else-if="currentTab === 'Sources'" />
      <DatabaseLabor v-else-if="currentTab === 'Labor'" />
      <DatabaseEquipment v-else-if="currentTab === 'Equipment'" />
      <DatabaseUnitsOfMeasure v-else-if="currentTab === 'UOM'" />
      <DatabaseEstimateStatus v-else-if="currentTab === 'Status'" />
      <DatabaseEstimateTypes v-else-if="currentTab === 'Types'" />
    </BaseTabs>
  </div>
</template>
